import { WBSection } from "@/components/wb-ui/wb-section"
import type { MarketPeerCompany } from "@/db/queries/market"

import { TopInstallerCard } from "./top-installer-card"

export type TopInstallersMarket = {
  name: string
  poolSize: number
  pageHref: string | null
}

export function TopInstallersSection({
  title,
  companies,
  market,
}: {
  title: string
  companies: MarketPeerCompany[]
  market: TopInstallersMarket
}) {
  if (!companies.length) return null

  return (
    <WBSection title={title}>
      <div className="flex flex-col gap-4">
        {companies.map((company) => (
          <TopInstallerCard
            key={company.longSlug}
            company={company}
            poolSize={market.poolSize}
          />
        ))}
      </div>
      {/* {market.pageHref && (
        <div className="mt-6">
          <Link
            to={market.pageHref}
            className="text-brand hover:text-brand/80 font-semibold"
          >
            See all {market.name} installers &rarr;
          </Link>
        </div>
      )} */}
    </WBSection>
  )
}
